const meta = {
  moduleName: 'containers_module',
  description: 'Containers module / Module contenant',
  storeName: 'containersModuleStore',
  cached: false,
  requiredRights: ['GEOV3_CONTENANTS_ACCESS'],
  functionId: 421,
}
export default {
  path: '/containers-module',
  name: 'containers_module',
  meta,
  redirect: '/containers-module/selection', // default child route
  component: () =>
    import(/* webpackChunkName: "main" */ '@/views/ContainersModule.vue'),
  children: [
    {
      path: '/containers-module/selection',
      name: 'containers_module_selection',
      meta: {
        ...meta,

        //requiredRights: ['GEOV3_BLACKSPOT_CONTRAINTS_EDIT'],
      },
      component: () =>
        import(
          /* webpackChunkName: "main" */ '@/views/ContainersModuleSelectionView.vue'
        ),
    },
    {
      path: '/containers-module/list',
      name: 'containers_module_list',
      meta: {
        ...meta,
        //requiredRights: ['GEOV3_BLACKSPOT_CONTRAINTS_EDIT'],
      },
      component: () =>
        import(
          /* webpackChunkName: "main" */ '@/views/ContainersModuleListMapView.vue'
        ),
    },
  ],
}
